import { motion } from "framer-motion"
import { Mail, MapPin, Phone } from "lucide-react"
import { useState } from "react"
import { useTranslation } from "react-i18next"

export default function Contact() {
  const { t } = useTranslation()
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")

  const handleSubmit = (e) => {
    e.preventDefault()
    const subject = encodeURIComponent("Poptávka")
    const body = encodeURIComponent(
      `Jméno: ${name}\nEmail: ${email}\n\n${message}`
    )
    window.location.href = `mailto:office@autodopravachochola.cz?subject=${subject}&body=${body}`
  }

  return (
    <section
      id="kontakt"
      className="py-24 bg-gray-50 dark:bg-gray-700 px-4 scroll-mt-4 md:scroll-mt-10"
    >
      <motion.h2
        initial={{ y: 20, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
        className="text-3xl font-semibold text-center mb-12 text-primary"
      >
        {t("contactSection.title")}
      </motion.h2>
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 md:gap-14">
        <motion.form
          onSubmit={handleSubmit}
          whileInView={{ opacity: 1, y: 0 }}
          initial={{ opacity: 0, y: 50 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg grid gap-8"
        >
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            placeholder={t("contactSection.namePlaceholder")}
            className="p-4 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary dark:bg-gray-900 dark:border-gray-600 dark:text-gray-200"
          />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder={t("contactSection.emailPlaceholder")}
            className="p-4 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary dark:bg-gray-900 dark:border-gray-600 dark:text-gray-200"
          />
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            placeholder={t("contactSection.messagePlaceholder")}
            rows="5"
            className="p-4 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary dark:bg-gray-900 dark:border-gray-600 dark:text-gray-200 max-h-64 resize-none"
          />
          <button
            type="submit"
            className="py-4 bg-primary text-white font-semibold rounded-lg hover:bg-primary transition"
          >
            {t("contactSection.submit")}
          </button>
        </motion.form>
        <motion.div
          whileInView={{ opacity: 1, y: 0 }}
          initial={{ opacity: 0, y: 50 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col justify-between gap-6 h-full overflow-hidden"
        >
          <div>
            <h3 className="text-2xl font-semibold text-primary mb-2">
              {t("contactSection.helpTitle")}
            </h3>
            <p className="mb-4 text-gray-700 dark:text-gray-200">
              {t("contactSection.helpText")}
            </p>
            <div className="flex flex-col gap-4 mt-6">
              {t("contactSection.sections", { returnObjects: true }).map(
                (sec) => (
                  <div key={sec.title} className="flex items-center space-x-3">
                    {sec.icon === "Phone" && (
                      <Phone className="w-6 h-6 text-primary" />
                    )}
                    {sec.icon === "Email" && (
                      <Mail className="w-6 h-6 text-primary" />
                    )}
                    <div>
                      <p className="font-semibold">{sec.title}</p>
                      <a
                        href={`${
                          sec.icon === "Email" ? "mailto" : "tel"
                        }:${sec.text.replace(/\s+/g, "")}`}
                        className="hover:underline"
                      >
                        {sec.text}
                      </a>
                    </div>
                  </div>
                )
              )}
              <div className="flex items-center space-x-3">
                <MapPin className="w-6 h-6 text-primary" />
                <div>
                  <p className="font-semibold">
                    {t("contactSection.addressTitle")}
                  </p>
                  <span>{t("contactSection.address")}</span>
                </div>
              </div>
              <p className="text-xs mt-4 text-gray-700 dark:text-gray-200">
                {t("contactSection.legal")}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

/*

Účtárna
uctarna@autodopravachochola.cz

Hlavní účetní
chocholova@autodopravachochola.cz

Obchodní oddělení
office@autodopravachochola.cz

Fakturační adresa


Adresa sídla
Revoluční 1082/8, Nové Město (Praha 1), 110 00 Praha

- Odstranit skladování zboží
- Opravit expressní služby
- Fakturantka
*/
